import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f54a862"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "purchases-list" }
const _hoisted_2 = { class: "scroll-component-container" }
const _hoisted_3 = { class: "table-responsive mb-16" }
const _hoisted_4 = { class: "fit text-center" }
const _hoisted_5 = {
  colspan: "2",
  class: "fit text-center"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  colspan: "222222",
  class: "empty-state py-8 px-12 text-center"
}
const _hoisted_8 = { class: "h-100 w-100 d-flex flex-column align-items-center justify-content-center text-center" }
const _hoisted_9 = { class: "h5 title text-primary mb-48" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-add me-12",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_11 = { class: "fit text-center" }
const _hoisted_12 = ["colspan"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-view-light",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_14 = { class: "fw-normal" }
const _hoisted_15 = {
  key: 0,
  class: "fit text-center"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-message",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_17 = { class: "fw-normal" }
const _hoisted_18 = {
  key: 0,
  class: "d-flex justify-content-end"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-add me-12",
  "aria-hidden": "true"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_table_header = _resolveComponent("v-table-header")!
  const _component_v_button = _resolveComponent("v-button")!
  const _component_v_table_body = _resolveComponent("v-table-body")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_the_purchase_authorization_create = _resolveComponent("the-purchase-authorization-create")!
  const _component_the_purchase_authorization_show = _resolveComponent("the-purchase-authorization-show")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_v_table, { class: "table-bordered" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_table_header, null, {
                default: _withCtx(() => [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t('Fecha vencimiento')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('Productos')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('Estado')), 1),
                    _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t('Acciones')), 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_table_body, null, {
                default: _withCtx(() => [
                  (!_ctx.purchaseAuthorizations || !_ctx.purchaseAuthorizations.length)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                        _createElementVNode("td", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('No hay autorizaciones de compra')), 1),
                            (_ctx.can('professional.expedient.purchase-authorization.store'))
                              ? (_openBlock(), _createBlock(_component_v_button, {
                                  key: 0,
                                  variant: "secondary",
                                  class: "btn-icon",
                                  "aria-label": _ctx.$t('Nueva autorización de compra'),
                                  onClick: _ctx.showPurchaseAuthorizationCreateModal
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_10,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('Nueva autorización de compra')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["aria-label", "onClick"]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.purchaseAuthorizations, (purchaseAuthorization) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: purchaseAuthorization.id
                        }, [
                          _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.$str.formatDate(purchaseAuthorization.dueDate)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.$t('{count} productos distintos', { count: purchaseAuthorization.products.length })), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.$t(_ctx.status(purchaseAuthorization))), 1),
                          _createElementVNode("td", {
                            class: "fit text-center",
                            colspan: purchaseAuthorization.status === 'pending' ? 1 : 2
                          }, [
                            _createVNode(_component_v_button, {
                              variant: "icon",
                              "aria-label": _ctx.$t('Visualizar'),
                              class: "d-flex flex-column p-0 m-auto",
                              onClick: ($event: any) => (_ctx.showPurchaseAuthorizationShowModal(purchaseAuthorization))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_13,
                                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('Ver')), 1)
                              ]),
                              _: 2
                            }, 1032, ["aria-label", "onClick"])
                          ], 8, _hoisted_12),
                          (purchaseAuthorization.status === 'pending')
                            ? (_openBlock(), _createElementBlock("td", _hoisted_15, [
                                _createVNode(_component_v_button, {
                                  variant: "icon",
                                  "aria-label": _ctx.$t('Reenviar enlace'),
                                  class: "d-flex flex-column p-0 m-auto",
                                  onClick: ($event: any) => (_ctx.resendLink(purchaseAuthorization))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_16,
                                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('Reenviar')), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["aria-label", "onClick"])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      (_ctx.can('professional.expedient.purchase-authorization.store'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createVNode(_component_v_button, {
              variant: "secondary",
              class: "btn-icon",
              "aria-label": _ctx.$t('Nueva autorización de compra'),
              onClick: _ctx.showPurchaseAuthorizationCreateModal
            }, {
              default: _withCtx(() => [
                _hoisted_19,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('Nueva autorización de compra')), 1)
              ]),
              _: 1
            }, 8, ["aria-label", "onClick"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.modalToShow === 'the-purchase-authorization-create')
      ? (_openBlock(), _createBlock(_component_the_purchase_authorization_create, {
          key: 0,
          onPurchaseAuthorizationCreated: _cache[0] || (_cache[0] = ($event: any) => {_ctx.loadPurchaseAuthorizations(); _ctx.modalToShow = null}),
          onClosed: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalToShow = null))
        }))
      : _createCommentVNode("", true),
    (_ctx.modalToShow === 'the-purchase-authorization-show')
      ? (_openBlock(), _createBlock(_component_the_purchase_authorization_show, {
          key: 1,
          onClosed: _cache[2] || (_cache[2] = ($event: any) => {_ctx.modalToShow = null; _ctx.setCurrentPurchase()})
        }))
      : _createCommentVNode("", true)
  ], 64))
}